import { useCallback, useEffect, useRef, useState } from "react";

const useEventListener = (event: string, listener: () => void, useCapture?: boolean) => {
  useEffect(() => {
    if (listener) {
      listener();
      window.addEventListener(event, listener, useCapture);

      return () => window.removeEventListener(event, listener, useCapture);
    }

    return () => {};
  }, [event, listener, useCapture]);
};

const useElementDimensions = () => {
  const ref = useRef<HTMLElement | null>(null);
  const [dimensions, setDimensions] = useState<{ height: number; width: number } | null>(null);

  const refresh = useCallback(() => {
    const domRect = ref.current?.getBoundingClientRect();

    if (domRect) {
      setDimensions(domRect);
    }
  }, []);

  useEventListener("resize", refresh);
  useEventListener("scroll", refresh, true);

  return { dimensions, ref, refresh };
};

export default useElementDimensions;
